module.exports = __webpack_public_path__ + "static/media/device_other.53316d43.svg";